import { render, staticRenderFns } from "./Deplacement.vue?vue&type=template&id=83cb3b7c&"
import script from "./Deplacement.vue?vue&type=script&lang=js&"
export * from "./Deplacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports